export default function() {
  'ngInject';

  function getStyle(element, status, progress) {
    const type = getElementType(element);
    if (['final', 'registered', 'started'].includes(status)) return `${type}-success`;
    if (['completed', 'reviewed'].includes(status)) return `${type}-primary`;
    if (['bundlePurchase', 'invitation', 'register', 'waitlisted'].includes(status) || (progress && progress.assigned))
      return `${type}-basic`;
    return `${type}-primary`;
  }

  function getText(status, progress) {
    if (status === 'bundlePurchase') return 'Purchase Bundle';
    if (status === 'invitation') return 'Invited';
    if (status === 'register' && progress && progress.assigned) return 'Assigned';
    if (status === 'registered') return 'Registered';
    if (status === 'waitlisted') return 'Waitlisted';
    if (['completed', 'reviewed'].includes(status)) return 'Complete';
    if (['started', 'final'].includes(status)) return 'In-Progress';
  }

  function getElementType(element) {
    const defaultType = 'btn';

    if (!element || !element.classList) return defaultType;

    const classList = Object.values(element.classList);

    if (classList.includes('label')) return 'label';
    if (classList.includes('badge')) return 'badge';
    return defaultType;
  }

  return {
    restrict: 'A',
    scope: {
      marketplaceLabel: '=',
      marketplaceProgress: '<'
    },
    link: function(scope, element) {
      let tempStyle;
      let tempText;

      scope.update = () => {
        tempStyle = getStyle(element[0], scope.marketplaceLabel, scope.marketplaceProgress);
        tempText = getText(scope.marketplaceLabel, scope.marketplaceProgress);

        if (tempText) {
          element.addClass(tempStyle);
          element[0].innerHTML = tempText;
        } else if (element && element[0]) {
          element.removeClass(element[0].className);
        }
      };

      scope.$watch('status', (newStatus, oldStatus) => {
        if (oldStatus) {
          element.removeClass(tempStyle);
        }
        scope.update();
      });

      scope.update();
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/marketplaceLabel/index.js